import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Ticketslist from "./Modules/Tickets/TicketsListHome";
import Ticketstableview from "./Modules/Tickets/Ticketstableview.jsx";
import Ticketslistview from "./Modules/Tickets/TicketsMailView.jsx";
import Ticketscardview from "./Modules/Tickets/Ticketscardview.jsx";

import Ticketsadd from "./Modules/Tickets/TicketsCreate";
import Ticketsview from "./Modules/Tickets/TicketView";
import Teamslist from "./Modules/Team/Teamslist";
import Dashboard from "./Modules/Dashboard/Dashboard";
import Componentlist from "./Modules/Component/Componentslist";
import Mailadd from "./Modules/Mail/Mailadd";
import Maillist from "./Modules/Mail/Maillist";
import Mailview from "./Modules/Mail/Mailview";
import Reportadd from "./Modules/Reports/Reportadd";
import Projectlist from "./Modules/Project/Projectlist";
import Projectadd from "./Modules/Project/Projectadd";
import Remoteview from "./Modules/Remote/Remoteview";
import Changepass from "./Modules/Topbar/Changepass";
import Clientadd from "./Modules/Client/Clientadd";
import Clientview from "./Modules/Client/Clientview";
import Clientlist from "./Modules/Client/Clientlist";
import Vendoradd from "./Modules/Vendor/vendor-add";
import Vendorview from "./Modules/Vendor/vendor-view";
import Vendorlist from "./Modules/Vendor/vendor-list";
import Register from "./Modules/Register/Register";
import Login from "./Modules/Login/Login";
import Componentadd from "./Modules/Component/Componentadd";
import { getCookie } from "./Modules/getcookie";
import { Navigate, Outlet } from "react-router-dom";
import { useGlobal } from "./GlobalContext";
import TicketCalendar from "./Modules/Tickets/ticket-calendar/Calendar-View";
import remoteWorkIcon from "./Assets/svg/remote-work.svg";
import ChatBot from "./Modules/ChatBot/Popups";
import Popup from "./Assets/svg/chat-bot/Popup.svg";
import ChatGPTTypingEffect from "./Modules/ChatBot/ChatGPTTyping";
import ApprovalAdd from "./Modules/Approval/ApprovalAdd";
import ApprovalList from "./Modules/Approval/ApprovalList";
import ApprovalView from "./Modules/Approval/ApprovalView";
import EscalationAdd from "./Modules/Escalation/EscalationAdd";
import EscalationList from "./Modules/Escalation/EscalationList";
import SummaryList from "./Modules/summary/summary-list";
import PreLanding from "./Modules/common/pre-landing.js";
import RegisterFieldList from "./Modules/registerfields/registerfield-list.jsx";
import Registerfieldsadd from "./Modules/registerfields/registerfieldadd.js";
import { getOrgLogoApi } from "./Modules/Topbar/topbar-api.js";
import HelpQuestions from "./Modules/common/help/help.js";
import MainLayout from "./Modules/common/main-layout.jsx";
import { apiCallAdmin } from "./services/api-service";
import WhatsNew from "./Modules/WhatsNew/whats-new";
import Workload from "./Modules/Workload/Workload";
import BudgetList from "./Modules/Budget/BudgetList";
import BudgetCreate from "./Modules/Budget/BudgetCreate";
import BudgetView from "./Modules/Budget/BudgetView";
import Handover from "./Modules/Handover/Handover";
import JunkMailList from "./Modules/JunkMail/JunkMailList";
import UnAuthorized from "./Modules/common/unauthorized.js";
function App() {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const environment = process.env.REACT_APP_ENVIRONMENT;

  const { rolePermissionList, setRolePermissionList, setUserType, setOrgImage } = useGlobal();

  useEffect(() => {
    const checkToken = async () => {
      try {
        console.log("🔍 Checking token validity...");

        const response = await apiCallAdmin("get", "validatetoken", null, {});

        console.log("✅ Token status:", response.status);

        if (response.status === 401) {
          handleInvalidToken();
        }
      } catch (err) {
        console.error("❌ Token validation failed:", err);
        handleInvalidToken();
      }
    };

    const handleInvalidToken = () => {
      const currentURL = window.location.href;

      const redirectData = {
        redirectPath: currentURL,
        app: "tickgo",
        ts: Date.now(),
      };

      console.warn("🔐 Saving redirect in window.name:", redirectData);

      // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
      window.name = JSON.stringify(redirectData);

      console.log("📌 window.name set:", window.name);

      // Clear token
      document.cookie = "mawalog=; path=/; domain=.mawalog.com; expires=Thu, 01 Jan 1970 00:00:00 GMT";

      console.log("➡️ Redirecting to login:", `${accountsUrl}/login`);
      window.location.href = `${accountsUrl}/login`;
    };

    // 🔥 IMPORTANT: run once on load
    console.log("🚀 Initial token check");
    checkToken();

    // Recheck when tab regains focus
    const onFocus = () => {
      console.log("👁 Window focused → rechecking token");
      checkToken();
    };

    window.addEventListener("focus", onFocus);

    return () => window.removeEventListener("focus", onFocus);
  }, []);
  useEffect(() => {
    getRolePermission();
    getOrgLogo();
    getMaiStatus();
  }, []);
  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response.success === true) {
        setOrgImage(response.image ?? "");
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  useEffect(() => {
    // const channel = new BroadcastChannel(`auth_channel_mawalog_${environment}`);

    // channel.onmessage = () => {
    //   window.location.reload();
    // };

    // return () => channel.close();
    window.addEventListener("mawalog_org_changed", (event) => {
      console.log(event.detail);
      if (event.detail === "changed") {
        window.location.reload();
      }
    });
  }, []);

  const [loading, setLoading] = useState(true);
  const [isMaiEnable, setIsMaiEnable] = useState(true);

  const getMaiStatus = async () => {
    try {
      const response = await apiCallAdmin("get", "get_mai_status/28", null, {});

      if (response.status === 200 && response.data.success) {
        setIsMaiEnable(response.data.status);
        console.log("response.data.status", response.data.status);
      } else {
      }
    } catch (err) {
      console.error("[DEBUG] Error fetching role permissions:", err);
    } finally {
    }
  };

  const getRolePermission = async () => {
    try {
      console.log("[DEBUG] Starting getRolePermission...");

      const response = await apiCallAdmin("get", "get_role_permission/28", null, {});

      if (response.status === 200 && response.data.success) {
        const userType = response.data.user_type;
        const rolePermissions = response.data.role_permission ?? [];

        setUserType(userType);
        setRolePermissionList(rolePermissions);

        localStorage.setItem("rolePermissionList", JSON.stringify(rolePermissions));
        localStorage.setItem("userType", userType ?? "");

        console.log("[DEBUG] User type set:", userType);
        console.log("[DEBUG] Role permissions set:", rolePermissions);
      } else {
        setRolePermissionList([]);
        console.log("[DEBUG] API returned success=false");
      }
    } catch (err) {
      console.error("[DEBUG] Error fetching role permissions:", err);
    } finally {
      setLoading(false);
      console.log("[DEBUG] getRolePermission finished");
    }
  };

  function checkPermission(menuName, permission) {
    console.log(rolePermissionList);
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  const ProtectedRoute = ({ isAllowed }) => {
    console.log("isAllowed", isAllowed);
    return isAllowed ? <Outlet /> : <Navigate to="/unauthorized" />;
  };

  const [showModal, setShowModal] = useState(false);
  const [showChatBot, setShowChatBot] = useState(false);
  return (
    <div className="App">
      <BrowserRouter>
        {loading ? (
          <p></p>
        ) : (
          <div style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<PreLanding />} />
              <Route path="/help" element={<HelpQuestions />} />
              {/* <Route path='/' element={<Ticketslist/>} /> */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Ticket", "list_permission")} />}>
                <Route
                  path="/ticket"
                  element={
                    <MainLayout selectedTab="Tickets">
                      <Ticketslist />
                    </MainLayout>
                  }
                />
              </Route>
              <Route path="/register" element={<Register />} />
              <Route element={<ProtectedRoute isAllowed={checkPermission("Client", "list_permission")} />}>
                <Route
                  path="/client/list"
                  element={
                    <MainLayout selectedTab="Client">
                      <Clientlist />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Client", "create_permission")} />}>
                <Route
                  path="/client/add"
                  element={
                    <MainLayout selectedTab="Client">
                      <Clientadd />
                    </MainLayout>
                  }
                />
              </Route>

              <Route element={<ProtectedRoute isAllowed={checkPermission("Client", "view_permission")} />}>
                <Route
                  path="/client/view"
                  element={
                    <MainLayout selectedTab="Client">
                      <Clientview />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Vendor", "create_permission")} />}>
                <Route
                  path="/vendor/add"
                  element={
                    <MainLayout selectedTab="Vendor">
                      <Vendoradd />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Vendor", "list_permission")} />}>
                <Route
                  path="/vendor/list"
                  element={
                    <MainLayout selectedTab="Vendor">
                      <Vendorlist />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Vendor", "view_permission")} />}>
                <Route
                  path="/vendor/view"
                  element={
                    <MainLayout selectedTab="Vendor">
                      <Vendorview />
                    </MainLayout>
                  }
                />
              </Route>
              <Route path="/remote" element={<Remoteview />} />
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute isAllowed={checkPermission("Mail configuration", "list_permission")} />}>
                <Route
                  path="/mail/list"
                  element={
                    <MainLayout selectedTab="Mail Configuration">
                      <Maillist />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Mail configuration", "create_permission")} />}>
                <Route
                  path="/mail/add"
                  element={
                    <MainLayout selectedTab="Mail Configuration">
                      <Mailadd />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Mail configuration", "view_permission")} />}>
                <Route
                  path="/mail/view"
                  element={
                    <MainLayout selectedTab="Mail Configuration">
                      <Mailview />
                    </MainLayout>
                  }
                />
              </Route>

              <Route element={<ProtectedRoute isAllowed={checkPermission("Approval", "list_permission")} />}>
                <Route
                  path="/approval/list"
                  element={
                    <MainLayout selectedTab="Approval">
                      <ApprovalList />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Approval", "create_permission")} />}>
                <Route
                  path="/approval/add"
                  element={
                    <MainLayout selectedTab="Approval">
                      <ApprovalAdd />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Approval", "view_permission")} />}>
                <Route
                  path="/approval/view"
                  element={
                    <MainLayout selectedTab="Approval">
                      <ApprovalView />
                    </MainLayout>
                  }
                />
              </Route>

              <Route element={<ProtectedRoute isAllowed={checkPermission("Escalation", "list_permission")} />}>
                <Route
                  path="/escalation/list"
                  element={
                    <MainLayout selectedTab="Escalation">
                      <EscalationList />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Escalation", "create_permission")} />}>
                <Route
                  path="/escalation/add"
                  element={
                    <MainLayout selectedTab="Escalation">
                      <EscalationAdd />
                    </MainLayout>
                  }
                />
              </Route>

              <Route element={<ProtectedRoute isAllowed={checkPermission("Field configuration", "list_permission")} />}>
                <Route
                  path="/register/list"
                  element={
                    <MainLayout selectedTab="Field configuration">
                      <RegisterFieldList />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Field configuration", "create_permission")} />}>
                <Route
                  path="/register/add"
                  element={
                    <MainLayout selectedTab="Field configuration">
                      <Registerfieldsadd />
                    </MainLayout>
                  }
                />
              </Route>

              <Route path="/change/password" element={<Changepass />} />
              <Route element={<ProtectedRoute isAllowed={checkPermission("Dashboard", "menu_permission")} />}>
                <Route
                  path="/dashboard"
                  element={
                    <MainLayout selectedTab="Dashboard">
                      <Dashboard />
                    </MainLayout>
                  }
                />
                <Route
                  path="/whats-new"
                  element={
                    <MainLayout selectedTab="What's New">
                      <WhatsNew />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Summary", "list_permission")} />}>
                <Route
                  path="/summary"
                  element={
                    <MainLayout selectedTab="summary">
                      <SummaryList />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Ticket", "list_permission")} />}>
                <Route path="/ticket/table" element={<Ticketstableview />} />
                <Route path="/ticket/list" element={<Ticketslistview />} />
                <Route path="/ticket/card" element={<Ticketscardview />} />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Ticket", "create_permission")} />}>
                <Route
                  path="/ticket/add"
                  element={
                    <MainLayout selectedTab="Tickets">
                      <Ticketsadd />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Ticket", "view_permission")} />}>
                <Route
                  path="/ticket/view/:id"
                  element={
                    <MainLayout selectedTab="Tickets">
                      <Ticketsview />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Project", "list_permission")} />}>
                <Route
                  path="/project"
                  element={
                    <MainLayout selectedTab="Project">
                      <Projectlist />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Project", "create_permission")} />}>
                <Route
                  path="/project/add"
                  element={
                    <MainLayout selectedTab="Project">
                      <Projectadd />
                    </MainLayout>
                  }
                />
              </Route>
              {/* <Route path='/module' element={<Modulelist/>} /> */}
              <Route element={<ProtectedRoute isAllowed={checkPermission("Component", "list_permission")} />}>
                <Route
                  path="/component"
                  element={
                    <MainLayout selectedTab="Component">
                      <Componentlist />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Component", "create_permission")} />}>
                <Route
                  path="/component/add"
                  element={
                    <MainLayout selectedTab="Component">
                      <Componentadd />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Team", "list_permission")} />}>
                <Route
                  path="/team"
                  element={
                    <MainLayout selectedTab="Team">
                      <Teamslist />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Handover", "menu_permission") || checkPermission("Report", "menu_permission") || true} />}>
                <Route
                  path="/handover"
                  element={
                    <MainLayout selectedTab="Handover">
                      <Handover />
                    </MainLayout>
                  }
                />
              </Route>
              <Route element={<ProtectedRoute isAllowed={checkPermission("Report", "menu_permission")} />}>
                <Route
                  path="/report"
                  element={
                    <MainLayout selectedTab="Report">
                      <Reportadd />
                    </MainLayout>
                  }
                />
              </Route>
              <Route path="/workload" element={
                <MainLayout selectedTab="Workload">
                  <Workload />
                </MainLayout>
              } />
              <Route path="/junk-mail" element={
                <MainLayout selectedTab="Junk Mail">
                  <JunkMailList />
                </MainLayout>
              } />
              <Route path="/budget" element={
                <MainLayout selectedTab="Budget">
                  <BudgetList />
                </MainLayout>
              } />
              <Route path="/budget/add" element={
                <MainLayout selectedTab="Budget">
                  <BudgetCreate />
                </MainLayout>
              } />
              <Route path="/budget/view" element={
                <MainLayout selectedTab="Budget">
                  <BudgetView />
                </MainLayout>
              } />
              <Route path="/budget/edit/:id" element={
                <MainLayout selectedTab="Budget">
                  <BudgetCreate />
                </MainLayout>
              } />
              <Route path="/calendarview" element={<TicketCalendar />} />
              <Route path="/karaoreading" element={<ChatGPTTypingEffect />} />
              <Route path="/unauthorized" element={<UnAuthorized />} />
              <Route path="*" element={<UnAuthorized />} />
            </Routes>
          </div>
        )}
        {showModal && <Remoteview show={showModal} onHide={() => setShowModal(false)} />}

        {showChatBot && <ChatBot show={showChatBot} onHide={() => setShowChatBot(false)} />}
      </BrowserRouter>
      {/* {isMaiEnable && (
        <img
          src={Popup}
          width={"50px"}
          height={"50px"}
          onClick={() => {
            setShowChatBot(true);
          }}
          style={{
            position: "fixed",
            bottom: "90px",
            right: "20px",
            cursor: "pointer",
            background: "transparent",
          }}
          alt="mai"
        />
      )} */}
      {/* <button
      style={{
        position: "fixed",
        bottom: "80px",
        right: "20px",
        background: "transparent",
        color: "transparent",
        border: "none",
        borderRadius: "40px",
        width: "50px",
        height: "50px",
        boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.2)",
        cursor: "pointer",

      }}

    >

    </button> */}
      {checkPermission("Remote Work", "menu_permission") && (
        <button
          style={{
            position: "fixed",
            bottom: "40px",
            right: "20px",
            background: "linear-gradient(to bottom, #6929E2, #304FFF)",
            color: "#fff",
            border: "none",
            borderRadius: "40px",
            width: "154px",
            height: "40px",
            boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.2)",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "600",
            fontFamily: "Satoshi",
          }}
          onClick={() => {
            setShowModal(true);
          }}
        >
          <img src={remoteWorkIcon} /> <span style={{ fontSize: "12px" }}>Remote Work</span>
        </button>
      )}
    </div>
  );
}

export default App;
